module.exports = __webpack_public_path__ + "media/images/short-text-a1655d595a06003b0295b5c44a792106.svg";